import Home from "@/views/Home"
let routers = [
    {
      path: "/",
      redirect: "/home"
    },
    {
        path: '/home',
        title: '',
        name: 'home',
        component: Home,
    }
];
export default routers
